import { Box, Paper } from '@mui/material'
import { MarkdownContent } from './MarkdownContent.js'
import { ReasoningPanel } from './ReasoningPanel.js'
import { ToolChip } from './ToolChip.js'
import type { StreamingTurn } from '../chat/useChatSession.js'

const cursorSx = {
  display: 'inline-block',
  width: '0.5em',
  height: '1em',
  bgcolor: 'text.primary',
  ml: 0.5,
  verticalAlign: 'text-bottom',
  animation: 'blink 1s step-start infinite',
  '@keyframes blink': { '50%': { opacity: 0 } },
}

export const StreamingBubble = ({ turn }: { turn: StreamingTurn }) => (
  <Box display="flex" justifyContent="flex-start" mb={2}>
    <Paper
      elevation={0}
      sx={{ maxWidth: '75%', p: 1.5, border: '1px solid', borderColor: 'divider' }}
    >
      {turn.reasoning && (
        <ReasoningPanel reasoning={turn.reasoning} hasFinalText={turn.content.length > 0} />
      )}
      {turn.toolCalls.length > 0 && (
        <Box mb={1}>
          {turn.toolCalls.map((call) => (
            <ToolChip key={call.toolCallId} call={call} />
          ))}
        </Box>
      )}
      {turn.content.length > 0 && <MarkdownContent content={turn.content} />}
      <Box component="span" sx={cursorSx} />
    </Paper>
  </Box>
)
